import React from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import StarChecked from '@/assets/star.svg';
import StarNormal from '@/assets/star-stroke.svg';
import useStyle from './style';

const Rate = ({
  readOnly,
  value,
  max,
  onChange,
  size,
  className,
  ariaLabel,
  ...rest
}) => {
  const classes = useStyle();

  const handleRateIconClick = (newValue) => () => {
    if (!readOnly) {
      onChange(newValue);
    }
  };

  const RateIcon = ({ isChecked, onClick }) => {
    const props = {
      width: size,
      height: size,
      _text_color: value ? 'primary2' : 'gray',
      onClick,
    };
    return isChecked ? <StarChecked {...props} /> : <StarNormal {...props} />;
  };


  return (
    <div
      className={cx(
        classes.rate,
        readOnly && 'readonly',
        className,
      )}
      {...rest}
    >
      {new Array(max).fill(null).map((v, index) => (
        // eslint-disable-next-line react/no-array-index-key, max-len
          <button
              onClick={handleRateIconClick(index + 1)}
              key={index}
              aria-selected={index + 1 <= value}
              aria-label={`${ariaLabel || "star"} ${index + 1}`}>
            <RateIcon isChecked={index + 1 <= value} />
          </button>
      ))}
    </div>
  );
};


Rate.propTypes = {
  readOnly: PropTypes.bool,
  value: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
  size: PropTypes.number,
  ariaLabel: PropTypes.string,
};

Rate.defaultProps = {
  readOnly: false,
  value: 0,
  max: 5,
  onChange: () => {},
  size: 36,
  ariaLabel: null
};

export default Rate;
